export const styles = {
    devIcon: { width: '150px', borderRadius: 5 },
    contentStyle: {
        margin: 0,
        paddingTop: '12%',
        paddingBottom: '12%',
        color: '#fff',
        textAlign: 'center',
    },
    nameTitle: {
        textTransform: 'uppercase',
    },
    mb_50: {
        marginBottom: 50,
    },
    fiverrIcon: { width: '100px', display: 'none' },
}
